export default "/images/vendor/flag-icons/flags/4x3/co.svg?2035da4efa474be5bb4bf93fb3d73174";